var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"page-title"},[_vm._t("default"),_vm._v(" "),(_vm.$slots.right)?_c('div',{staticClass:"right"},[_vm._t("right")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }